function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4ZM10.2128 10.4652C10.4415 9.98126 10.6471 9.54629 10.6471 8.82353C10.6471 7.26414 9.38292 6 7.82353 6C6.26414 6 5 7.26414 5 8.82353C5 9.95097 5.36898 12.4 5.84018 14.4706H9.67651C9.43029 12.1209 9.85056 11.2316 10.2128 10.4652ZM9.87729 15.8824H6.19618C6.26754 16.135 6.33965 16.3719 6.41176 16.5882C6.56838 17.0581 7.11765 18 8.17647 18C9.23529 18 9.9827 16.9412 9.94118 16.2353C9.91861 16.115 9.89733 15.9973 9.87729 15.8824ZM13.4 8.82353C13.4 9.54629 13.6056 9.98126 13.8343 10.4652C14.1965 11.2316 14.6168 12.1209 14.3706 14.4706H18.2069C18.6781 12.4 19.0471 9.95097 19.0471 8.82353C19.0471 7.26414 17.7829 6 16.2235 6C14.6642 6 13.4 7.26414 13.4 8.82353ZM17.8509 15.8824H14.1698C14.1497 15.9973 14.1285 16.115 14.1059 16.2353C14.0644 16.9412 14.8118 18 15.8706 18C16.9294 18 17.4787 17.0581 17.6353 16.5882C17.7074 16.3719 17.7795 16.135 17.8509 15.8824Z",
  fill: "#02786D"
});

var SvgWeight = function SvgWeight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWeight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/weight.2972657d.svg";
export { ForwardRef as ReactComponent };